import React from 'react';

const ChooseBuffetMenu = ({ buffetMenu, setBuffetMenu, error, setError }) => {

  const menuOptions = [
    { label: 'Simple Buffet', value: 'simpleThali', description: 'A simple thali with rice, dal, vegetable, 4 chapati and salad', price: 90 },
    { label: 'Special Buffet', value: 'paneerThali', description: 'A delicious paneer thali with paneer, rice, vegetable, 4 chapati and salad.', price: 125 },
    { label: 'Others', value: 'others', description: 'Buffet of your choice' },
  ];

  const handleTileClick = (value) => {
    setBuffetMenu(value);
    if (error) setError('');
  };

  return (
    <div className="step-section">
      <div className="step-tiles">
        {menuOptions.map(option => (
          <div
            key={option.value}
            className={`step-tile${buffetMenu === option.value ? ' selected' : ''}`}
            onClick={() => handleTileClick(option.value)}
          >
            <div className="step-tile-label">{option.label}</div>
            <div className="step-tile-desc">{option.description}
              {option.extra && (
                <div className="step-tile-extra">{option.extra}</div>
              )}
            </div>
            <div className="step-tile-price">{ option.price ? `₹${option.price}/plate` : ''}</div>
          </div>
        ))}
      </div>
      {error && (
        <div className="field-error step-error">{error}</div>
      )}
    </div>
  );
};

export default ChooseBuffetMenu;
